export default class LocalStorageService {
  getCurrentOrgID() {
    const orgJSON = window.localStorage.getItem('currentOrg');
    if (!orgJSON) return '';
    const { _id = '' } = JSON.parse(orgJSON);
    return _id;
  }
  getObjectByKey(key) {
    const stringifiedItem = window?.localStorage?.getItem?.(key);
    if (!stringifiedItem) return;

    return JSON.parse(stringifiedItem);
  }
  setObject(key, obj) {
    window?.localStorage?.setItem?.(key, JSON.stringify(obj));
  }
}
